import { Button } from '@mantine/core';
import clsx from 'clsx';
import { Eye, Pencil } from 'lucide-react';
import type { FC, MouseEvent } from 'react';
import styles from './flow-card-actions.module.css';

interface FlowCardMenuProps {
	onEdit: (ev: MouseEvent<HTMLButtonElement>) => void;
	isFromLibrary?: boolean;
	color: string;
}

const FlowCardActions: FC<FlowCardMenuProps> = ({
	onEdit,
	isFromLibrary,
	color
}) => (
	<Button
		className={clsx(styles.flowCardAction, {
			[styles.editButton]: !isFromLibrary
		})}
		onClick={onEdit}
	>
		{isFromLibrary ? (
			<Eye
				className={styles.icon}
				color={color}
			/>
		) : (
			<Pencil
				className={styles.icon}
				color="white"
			/>
		)}
	</Button>
);

export default FlowCardActions;
